<div class="container-fluid">
    <app-pagetitle title="S3 Bucket Integration" [subtitle]="'Configure and manage your AWS S3 bucket connection'">
    </app-pagetitle>

    <div class="page-content-wrapper">
        <div [class.loading-content]="loading">
            <app-loader [loading]="loading"></app-loader>

            <div class="row">
                <div class="col-lg-12">

                    <div class="card border-0 shadow-sm">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <p class="fw-bold fs-5 mb-0">S3 Bucket Integration</p>
                        </div>
                        <div class="card-body d-flex align-items-center justify-content-between p-3">

                            <!-- Left Content -->
                            <div class="d-flex align-items-center gap-3">

                                @if(isS3Configured){
                                <div class="bg-success-subtle rounded-circle d-flex align-items-center justify-content-center"
                                    style="width: 50px; height: 50px;">
                                    <i class="ri-cloud-line text-success fs-4"></i>
                                </div>
                                }

                                @if(!isS3Configured){
                                <div class="bg-light rounded-circle d-flex align-items-center justify-content-center"
                                    style="width: 50px; height: 50px;">
                                    <i class="ri-cloud-off-line text-muted fs-4"></i>
                                </div>
                                }

                                <div>
                                    <h6 class="fw-bold mb-1">
                                        AWS S3 Bucket
                                    </h6>

                                    @if(loading){
                                    <small class="text-muted">
                                        Loading...
                                    </small>
                                    }

                                    @if(!loading && isS3Configured){
                                    <small class="text-success">
                                        S3 Bucket {{customerProfile?.s3Bucket?.isS3Connected ? 'Connected' : 'Connect'}}
                                    </small>
                                    }

                                    @if(!loading && !isS3Configured){
                                    <small class="text-muted">
                                        Not Configured
                                    </small>
                                    }
                                </div>
                            </div>

                            <!-- Right Button -->
                            <div>

                                @if(!loading && !isS3Configured){
                                <button class="btn btn-primary btn-sm" (click)="openS3SetupModal()">
                                    <i class="ri-settings-3-line me-1"></i>
                                    Setup
                                </button>
                                }

                                @if(!loading && isS3Configured){
                                <div class="form-check form-switch d-flex align-items-center gap-2">
                                    <input class="form-check-input cursor-pointer" type="checkbox" role="switch"
                                        [checked]="customerProfile?.s3Bucket?.isS3Connected"
                                        (change)="toggleS3BucketStatus($event)"
                                        [title]="customerProfile?.s3Bucket?.isS3Connected ? 'Deactivate S3 Bucket' : 'Activate S3 Bucket'" />

                                    <label class="form-check-label fw-semibold"
                                        [class.text-success]="customerProfile?.s3Bucket?.isS3Connected"
                                        [class.text-muted]="!customerProfile?.s3Bucket?.isS3Connected">
                                        {{ customerProfile?.s3Bucket?.isS3Connected ? 'Active' : 'Inactive' }}
                                    </label>
                                </div>
                                }

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <app-filter searchPlaceholder="Filename" (filterChange)="onFilterChange($event)"
                                searchHint="Filename">
                            </app-filter>
                        </div>
                        <div class="card-body">

                            <p-table #dt [value]="documents" [lazy]="true" (onLazyLoad)="getS3Documents($event)"
                                [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
                                [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Filename</th>
                                        <th>Provider</th>
                                        <th>Created Date</th>
                                        <th>Action</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-data>
                                    <tr>
                                        <td>
                                            <div class="fw-semibold">{{ data.original_filename || '-' }}</div>
                                        </td>
                                        <td>{{ data?.provider || '-' }}</td>

                                        <td>{{ data.created_at | date: 'dd MMM yyyy' }}</td>
                                        <td>
                                            <button class="btn btn-sm btn-outline-primary py-0"
                                                (click)="downloadS3Document(data)" [ngbTooltip]="'Download Document'">
                                                <i class="mdi mdi-download fs-5"></i>
                                            </button>
                                        </td>

                                    </tr>



                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="9" class="text-center py-4 text-muted">
                                            <i class="mdi mdi-database-off-outline me-2"></i>
                                            No data found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        @if(showS3SetupModal){
        <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true"
            aria-labelledby="s3SetupModalTitle">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="s3SetupModalTitle">S3 Setup</h5>
                        <button type="button" class="btn-close" aria-label="Close" [disabled]="s3SetupLoading"
                            (click)="closeS3SetupModal()"></button>
                    </div>

                    <form [formGroup]="s3SetupForm" (ngSubmit)="setupS3Bucket()" autocomplete="off" novalidate>
                        <div class="modal-body">
                            <div class="mb-3">
                                <label for="s3AccessKeyId" class="form-label">Access Key ID</label>
                                <input id="s3AccessKeyId" type="text" class="form-control"
                                    name="s3_setup_access_key_identifier" autocomplete="new-password"
                                    autocapitalize="off" spellcheck="false" formControlName="access_key_id"
                                    [class.is-invalid]="(s3SetupSubmitted || s3SetupControls.access_key_id.touched) && s3SetupControls.access_key_id.invalid">
                                @if((s3SetupSubmitted || s3SetupControls.access_key_id.touched) &&
                                s3SetupControls.access_key_id.hasError('required')){
                                <div class="invalid-feedback">Access Key ID is required.</div>
                                } @else if((s3SetupSubmitted || s3SetupControls.access_key_id.touched) &&
                                s3SetupControls.access_key_id.hasError('pattern')){
                                <div class="invalid-feedback">Access Key ID cannot be blank.</div>
                                }
                            </div>

                            <div class="mb-3">
                                <label for="s3SecretAccessKey" class="form-label">Secret Access Key</label>
                                <div class="input-group"
                                    [class.has-validation]="(s3SetupSubmitted || s3SetupControls.secret_access_key.touched) && s3SetupControls.secret_access_key.invalid">
                                    <input id="s3SecretAccessKey" [type]="showSecretAccessKey ? 'text' : 'password'"
                                        class="form-control" name="s3_setup_secret_access_key"
                                        autocomplete="new-password" autocapitalize="off" spellcheck="false"
                                        formControlName="secret_access_key"
                                        [class.is-invalid]="(s3SetupSubmitted || s3SetupControls.secret_access_key.touched) && s3SetupControls.secret_access_key.invalid">
                                    <button class="btn btn-outline-secondary" type="button"
                                        [attr.aria-label]="showSecretAccessKey ? 'Hide Secret Access Key' : 'Show Secret Access Key'"
                                        (click)="toggleSecretAccessKeyVisibility()">
                                        <i [class.ri-eye-line]="showSecretAccessKey"
                                            [class.ri-eye-off-line]="!showSecretAccessKey"></i>
                                    </button>
                                    @if((s3SetupSubmitted || s3SetupControls.secret_access_key.touched) &&
                                    s3SetupControls.secret_access_key.hasError('required')){
                                    <div class="invalid-feedback">Secret Access Key is required.</div>
                                    } @else if((s3SetupSubmitted || s3SetupControls.secret_access_key.touched) &&
                                    s3SetupControls.secret_access_key.hasError('pattern')){
                                    <div class="invalid-feedback">Secret Access Key cannot be blank.</div>
                                    }
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="s3BucketName" class="form-label">Bucket Name</label>
                                <input id="s3BucketName" type="text" class="form-control" formControlName="bucket"
                                    [class.is-invalid]="(s3SetupSubmitted || s3SetupControls.bucket.touched) && s3SetupControls.bucket.invalid">
                                @if((s3SetupSubmitted || s3SetupControls.bucket.touched) &&
                                s3SetupControls.bucket.hasError('required')){
                                <div class="invalid-feedback">Bucket Name is required.</div>
                                } @else if((s3SetupSubmitted || s3SetupControls.bucket.touched) &&
                                s3SetupControls.bucket.hasError('pattern')){
                                <div class="invalid-feedback">Bucket Name cannot be blank.</div>
                                }
                            </div>

                            <div class="mb-3">
                                <label for="s3Region" class="form-label">Region</label>
                                <input id="s3Region" type="text" class="form-control" formControlName="region"
                                    [class.is-invalid]="(s3SetupSubmitted || s3SetupControls.region.touched) && s3SetupControls.region.invalid">
                                @if((s3SetupSubmitted || s3SetupControls.region.touched) &&
                                s3SetupControls.region.hasError('required')){
                                <div class="invalid-feedback">Region is required.</div>
                                } @else if((s3SetupSubmitted || s3SetupControls.region.touched) &&
                                s3SetupControls.region.hasError('pattern')){
                                <div class="invalid-feedback">Region cannot be blank.</div>
                                }
                            </div>

                            <div>
                                <label for="s3Folder" class="form-label">Folder</label>
                                <input id="s3Folder" type="text" class="form-control" formControlName="folder"
                                    [class.is-invalid]="(s3SetupSubmitted || s3SetupControls.folder.touched) && s3SetupControls.folder.invalid">
                                @if((s3SetupSubmitted || s3SetupControls.folder.touched) &&
                                s3SetupControls.folder.hasError('required')){
                                <div class="invalid-feedback">Folder is required.</div>
                                } @else if((s3SetupSubmitted || s3SetupControls.folder.touched) &&
                                s3SetupControls.folder.hasError('pattern')){
                                <div class="invalid-feedback">Folder cannot be blank.</div>
                                }
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" [disabled]="s3SetupLoading"
                                (click)="closeS3SetupModal()">Cancel</button>
                            <button type="submit" class="btn btn-primary" [disabled]="s3SetupLoading">
                                @if(s3SetupLoading){
                                <app-loader [buttonLoader]="true"></app-loader>
                                } @else {
                                Setup
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show"></div>
        }







        <!-- <div class="row">
        <div class="col-lg-12">
            <div class="card flex-fill">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <p class="fw-bold fs-5 mb-0">Payment Method</p>
                </div>
                <div class="card-body">
                    @if(loading){
                    <div class="text-center fw-bold">Loading data...</div>
                    }
                    @if(error){
                    <div class="alert alert-danger" role="alert">{{ error }}</div>
                    }
                    @if(!loading && false){
                    <div class="row mb-3">
                        <div class="col-6 text-start">
                            <div class="label fw-semibold mb-2">Visa ending in 4242</div>
                            <div class="value">Expires 12/2026</div>
                        </div>
                        <div class="col-6 text-end">
                            <button class="btn btn-primary">Update</button>
                        </div>
                    </div>
                    }
                    @if(!loading && true){
                    <div class="text-center fw-bold">No data available.</div>
                    }
                </div>
            </div>
        </div>
    </div> -->